import { render } from "./PageParameter.vue?vue&type=template&id=12ca655a&scoped=true"
import script from "./PageParameter.vue?vue&type=script&lang=js"
export * from "./PageParameter.vue?vue&type=script&lang=js"

import "./PageParameter.vue?vue&type=style&index=0&id=12ca655a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ca655a"]])

export default __exports__